export default __webpack_public_path__ + "static/media/contribute.e50a35d1.png";